import React from 'react';
import PropTypes from 'prop-types';

const TextInput = props => {
  const {className, id, value, onChange, name, label, size, inputClass, disabled} = props;
  return (
    <div
    className={className}
    >
    <label
      htmlFor={id}
    >
      {label}
    </label>
    <input
      id={id}
      type="text"
      name={name}
      size={size}
      value={value}
      onChange={onChange}
      className ={inputClass}
      disabled={disabled}
      />
    </div>
  )
};

TextInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.node,
  disabled: PropTypes.bool
};

export default TextInput;
